















































import * as _ from "lodash";
import moment from "moment";
import { Prop, Component, Vue } from 'vue-property-decorator';
import firebase from "firebase";

type Position = {
  x: number;
  y: number;
};

type Node = {

} & Position;


@Component({
  components: {
  }
})
export default class Draw extends Vue {
  viewBox = {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  }

  circle = {
    x: 0,
    y: 0,
    r: 100,
  }

  viewBoxOn: "on" | "off" = "on"
  par: string = "xMidYMid";
  meetOrSlice: "meet" | "slice" = "meet";
  get defPreserveAspectRatio() {
    return {
      none: "none",
      xMinYMin: "xMinYMin",
      xMaxYMin: "xMaxYMin",
      xMinYMid: "xMinYMid",
      xMidYMid: "xMidYMid",
      xMaxYMid: "xMaxYMid",
      xMinYMax: "xMinYMax",
      xMidYMax: "xMidYMax",
      xMaxYMax: "xMaxYMax",
    };
  }

  get svgbind() {
    return {
      viewBox: this.viewBoxOn === 'on' ? `${this.viewBox.x}, ${this.viewBox.y}, ${this.viewBox.width}, ${this.viewBox.height}` : '',
      preserveAspectRatio: `${this.par} ${this.meetOrSlice}`,
    };
  }


  nodes: Node[] = []
}
